import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "email", "label", "emailForm", "passwordForm"]

  connect() {
    this.change()
  }

  change() {
    if (!this.hasEmailTarget) return

    const passwordLogin = this.detailsTarget.open
    const form = passwordLogin ? this.passwordFormTarget : this.emailFormTarget

    this.emailTarget.name = passwordLogin ? this.emailTarget.dataset.passwordName : this.emailTarget.dataset.emailName
    this.emailTarget.setAttribute("form", form.id)
    this.labelTarget.textContent = passwordLogin ? this.labelTarget.dataset.passwordLabel : this.labelTarget.dataset.emailLabel
  }
}
